import "./Header.css"
// import { MenuOutlined } from "@ant-design/icons"
// import { useState } from "react"
function Header({ onData }) {



    // logo图片
    const LOGO = require('../../../assets/images/leyang-logo.png')

    return (
      <div className="m-header">
        <div className="m-menu">
          <section>
            <section className="m-header-logo">
              <img alt="logo" src={ LOGO } />
              <span>Joy Fashion</span>
            </section>
            {/* <div className="m-line-font">Professional Knitwear Manufactuer in China</div> */}
          </section>
          {/* <MenuOutlined className="m-right-icon" /> */}
        </div>
      </div>
    );
  }
  

  
  export default Header;